import { render, staticRenderFns } from "./ClaimAuditManagement.vue?vue&type=template&id=513c3759"
import script from "./ClaimAuditManagement.vue?vue&type=script&lang=js"
export * from "./ClaimAuditManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports